<div class="industry-analysis-page">
  <div class="content">
    <div class="top-action-section">
      <div class="filter-container">
        <div class="filter">
          <app-lineitem-filter
            [options]="ratioLineItemsData"
            [selectedValue]="{}"
            [selectedOptionsId]="selectedRatioId"
            liFilterId="industryValuationLI"
            [bottomBorderView]="true"
            [disabled]="
              isMetaInProgress ||
              isUserSettingUpdateInProgress ||
              isLineItemUpdateInProgress
            "
            placeholder="&nbsp;Add Ratios"
            label="Ratios"
            [showButton]="true"
            (onValueChange)="onSearchedLi($event)"
            (onEditButtonClick)="handleEditLineItemsButtonClick()"
          ></app-lineitem-filter>
        </div>
        <div class="filter">
          <va-period-filter
            [filterWidthVariation]="3"
            [periodData]="periodData"
            [disabled]="
              isMetaInProgress || isUserSettingUpdateInProgress || !periodData
            "
            [dataAvailable]="periodsWithAvailableData"
            (onApply)="handlePeriodApply($event)"
          ></va-period-filter>
        </div>
        <div class="filter industry-currency-filter">
          <va-currency-select
            size="small"
            selectWidth="78"
            labelPlacement="top"
            [bottomBorderView]="true"
            [selectedCurrency]="currency"
            [disabled]="isMetaInProgress || isUserSettingUpdateInProgress"
            [apiEP]="apiEP"
            apiUrl="/api/get_available_currencies"
            (onChange)="updateCurrency($event)"
          >
          </va-currency-select>
        </div>
      </div>
      <div class="cta-right-section">
        <div class="valuation-switch-item">
          <nz-radio-group
            [ngModel]="orientationValue"
            nzButtonStyle="solid"
            (ngModelChange)="handleOrientation($event)"
            [nzDisabled]="isMetaInProgress || isUserSettingUpdateInProgress"
            style="font-size: 12px"
          >
            <label nz-radio-button nzValue="grid">
              <va-icon
                size="small"
                isFontAwesome="true"
                [name]="faThLarge"
                class="icon"
                style="vertical-align: -10%"
              ></va-icon
              >Grid</label
            >
            <label nz-radio-button nzValue="list">
              <va-icon size="small" name="menu" class="icon"></va-icon
              >List</label
            >
          </nz-radio-group>
        </div>
        <app-export-to-excel-dropdown
          [(isPopoverVisible)]="isExportPopoverVisible"
          [disabled]="isMetaInProgress"
          [optionList]="excelToExportDropdownOptions"
          [isExportInProgress]="isExportInProgress"
          (onListItemClick)="handleETEListItemClick($event)"
        ></app-export-to-excel-dropdown>
      </div>
    </div>
    <div class="grid-section">
      <ng-container *ngIf="orientationValue === 'grid'">
        <div style="padding-top: 16px">
          <app-valuation-grid
            [gridData]="gridData"
            [showAverage]="true"
            [showMedian]="true"
            [orientation]="orientationValue"
            [periodState]="periodData"
            [highlightGAAP]="highlightGAAP"
            [visible]="true"
            containerClassName="industry-valuation-grid"
            [isDataInProgress]="isDataInProgress"
            sortByColumnId="marketCap"
          ></app-valuation-grid>
        </div>
      </ng-container>
      <ng-container *ngIf="orientationValue === 'list'">
        <ng-container *ngFor="let ratio of gridData.ratios">
          <ng-container *ngIf="ratio.charAt(0) !== '#'">
            <div style="padding-top: 16px">
              <app-valuation-grid
                [gridData]="gridData"
                [showAverage]="true"
                [showMedian]="true"
                [orientation]="orientationValue"
                [ratioId]="ratio"
                [periodState]="periodData"
                [highlightGAAP]="highlightGAAP"
                [visible]="true"
                containerClassName="industry-valuation-grid"
                sortByColumnId="marketCap"
              ></app-valuation-grid>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <div
      *ngIf="!isMetaInProgress"
      class="industry-val-footer"
      style="align-self: flex-end"
    >
      <div style="text-align: right">
        {{ magnitudeMessage }}
        <div *ngIf="factSetAccess" style="color: #b0b0b0">
          {{ factsetCopyRightMessage }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Snackbar -->
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon name="check" class="snack-icon snack-success-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon
      size="small"
      name="close-circle"
      class="snack-icon snack-failure-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon
      size="small"
      name="info-circle"
      class="snack-icon snack-info-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>

<app-no-ticker-popup
  [showNoTickerPopup]="isNoTickerPopupVisible"
  (onNoTickerPopupChangeClick)="onNoTickerPopupChangeClick()"
></app-no-ticker-popup>
